import { render, staticRenderFns } from "./PrizeDetail.vue?vue&type=template&id=55faf465&scoped=true&"
import script from "./PrizeDetail.vue?vue&type=script&lang=ts&"
export * from "./PrizeDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PrizeDetail.vue?vue&type=style&index=0&id=55faf465&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55faf465",
  null
  
)

component.options.__file = "PrizeDetail.vue"
export default component.exports